import type { ShipmentListItemVendorApi } from '@/views/screens/Shipment/types';

import { convertDateESTToUTCToUserLocal, convertDateUTCToUserLocal } from '../../utilz/dates';
import { DEFAULT_STORE_OBJECT } from '../constants';
import type { DefaultStoreObject } from '../types';
import POShipmentSearchTypes from './POShipmentSearchTypes';

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
export interface POShipmentSearchState extends Record<string, any> {
  shipmentInfoList: DefaultStoreObject<ShipmentListItemVendorApi[]> & {
    totalCount: number;
  };
  shipmentSearchExportVisible: boolean;
  isSelectedAllItemsForPoShipment: boolean;
}

const initialState: POShipmentSearchState = {
  isSelectedAllItemsForPoShipment: false,
  shipmentInfoList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    totalCount: 0,
  },
  shipmentInfoListReq: {
    carrierKey: 0,
    createdOnFrom: '',
    createdOnTo: '',
    customerKey: 0,
    orderByColumn: '',
    orderBySort: '',
    pageIndex: 0,
    pageSize: 10,
    poNumber: '',
    shipmentNo: '',
    shipmentType: 'Final',
    vendorKey: 0,
  },
  shipmentSearchExportData: {
    data: [],
  },
  shipmentSearchExportVisible: false,
};

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
const POShipmentSearchReducer = (state = initialState, { type, payload }: any): POShipmentSearchState => {
  switch (type) {
    case POShipmentSearchTypes.SET_SHIPMENT_SEARCH_EXPORT_TOGGLE: {
      return {
        ...state,
        shipmentSearchExportData: {
          data: payload.data,
        },
        shipmentSearchExportVisible: payload.show || false,
      };
    }
    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          progressing: true,
        },
      };
    }

    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST_SUCCESS: {
      payload.data?.item2.forEach((element: ShipmentListItemVendorApi) => {
        element.isChecked = state.isSelectedAllItemsForPoShipment || false;
        // @ts-expect-error TODO: migrate from moment and normalize
        element.expShipDate = convertDateUTCToUserLocal(element.expShipDate);
        // @ts-expect-error TODO: migrate from moment and normalize
        element.expDeliveryDate = convertDateUTCToUserLocal(element.expDeliveryDate);
        element.shipmentDate = convertDateESTToUTCToUserLocal(element.shipmentDate);
        element.createdOn = convertDateESTToUTCToUserLocal(element.createdOn);
      });
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          data: [...(state.shipmentInfoList.data || []), ...(payload?.data?.item2 ?? [])],
          progressing: false,
          success: true,
          totalCount: payload.data?.item1?.totalCount,
        },
      };
    }

    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST_FAIL: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          error: true,
          progressing: false,
          success: false,
        },
      };
    }

    case POShipmentSearchTypes.SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          progressing: true,
        },
      };
    }

    case POShipmentSearchTypes.SAVE_SHIPMENT_OTHER_DETAILS_FAIL: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          error: true,
          progressing: false,
          success: false,
        },
      };
    }

    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST_RESET: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          totalCount: 0,
        },
      };
    }

    case POShipmentSearchTypes.UPDATE_SHIPMENT_INFO_LIST_CHECKED_ITEMS: {
      const temp: ShipmentListItemVendorApi[] = [];
      state.shipmentInfoList.data?.forEach((item) => {
        if (payload === true || payload === false) {
          item.isChecked = payload;
        } else {
          if (payload.shipmentKey === item.shipmentKey) {
            item.isChecked = !item.isChecked;
          }
        }
        temp.push(item);
      });
      const findSelectedItem = state.shipmentInfoList.data?.filter((item) => item.isChecked);

      return {
        ...state,
        isSelectedAllItemsForPoShipment: Boolean(
          findSelectedItem?.length &&
            state.shipmentInfoList?.data?.length &&
            findSelectedItem?.length === state.shipmentInfoList?.data?.length,
        ),
        shipmentInfoList: {
          ...state.shipmentInfoList,
          data: temp,
        },
      };
    }

    case POShipmentSearchTypes.UPDATE_SHIPMENT_INFO_LIST_REQUEST: {
      return {
        ...state,
        shipmentInfoListReq: {
          ...state.shipmentInfoListReq,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default POShipmentSearchReducer;
